(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wf-collab"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__wfPagerInit) return;
  window.__wfPagerInit = true;
  function initPager(block){
    var rail = block.querySelector('[data-wf-rail]');
    var pg = block.querySelector('[data-wf-pg]');
    if(!rail || !pg) return;
    var prev = pg.querySelector('[data-wf-prev]'), next = pg.querySelector('[data-wf-next]'), cnt = pg.querySelector('[data-wf-count]');
    function pages(){ return Math.max(1, Math.round(rail.scrollWidth / rail.clientWidth)); }
    function cur(){ return Math.round(rail.scrollLeft / rail.clientWidth) + 1; }
    function sync(){
      var n = pages();
      if (n <= 1){ pg.hidden = true; return; }
      pg.hidden = false;
      var c = Math.min(cur(), n);
      cnt.textContent = c + ' of ' + n;
      prev.disabled = c <= 1;
      next.disabled = c >= n;
    }
    prev.addEventListener('click', function(){ rail.scrollBy({ left: -rail.clientWidth, behavior:'smooth' }); });
    next.addEventListener('click', function(){ rail.scrollBy({ left: rail.clientWidth, behavior:'smooth' }); });
    var raf; rail.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
    window.addEventListener('resize', sync);
    sync();
  }
  function initPagers(){ document.querySelectorAll('[data-wf-pager]').forEach(initPager); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPagers); else initPagers();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wf-quickview"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__wfQuickviewInit) return;
  window.__wfQuickviewInit = true;
  function el(s){ return document.querySelector(s); }
  function safeParse(s, fb){ try { return JSON.parse(s); } catch(e){ return fb; } }
  var curVid = null;
  function closeCartDrawer(){
    // 购物车抽屉是 top-layer <dialog>, z-index 盖不过它 -> 打开 quick-view 前先关掉
    var cd = document.querySelector('cart-drawer-component, cart-drawer');
    if (cd){
      if (typeof cd.close === 'function'){ try { cd.close(); return; } catch(e){} }
      if (typeof cd.closeDialog === 'function'){ try { cd.closeDialog(); return; } catch(e){} }
      var d = cd.querySelector ? cd.querySelector('dialog[open]') : null;
      if (d && d.close){ try { d.close(); } catch(e){} }
    }
  }
  function open(ds){
    var qv = el('[data-wf-qv]'); if(!qv) return;
    closeCartDrawer();
    curVid = ds.vid;
    var imgs = safeParse(ds.imgs, []);
    var main = el('[data-wf-qv-main]'); if(main) main.src = imgs.length ? imgs[0] : '';
    var thumbs = el('[data-wf-qv-thumbs]');
    thumbs.innerHTML = imgs.map(function(u,i){ return '<img src="'+u+'" data-wf-thumb alt="" loading="lazy" class="'+(i===0?'is-active':'')+'">'; }).join('');
    thumbs.style.display = imgs.length > 1 ? 'flex' : 'none';
    el('[data-wf-qv-title]').textContent = ds.title || '';
    el('[data-wf-qv-price]').innerHTML = ds.price || '';
    el('[data-wf-qv-sub]').textContent = ds.sub || '';
    var vars = safeParse(ds.variants, []);
    var vc = el('[data-wf-qv-variants]');
    if (vars.length > 1){
      vc.innerHTML = '<span class="wfc-qv-vlabel">Colour</span>' + vars.map(function(v,i){
        return '<button type="button" class="wfc-qv-vbtn'+(i===0?' is-sel':'')+'" data-vsel="'+v.id+'" data-vimg="'+(v.img||'')+'"'+(v.available?'':' disabled')+'>'+v.title+'</button>';
      }).join('');
      curVid = String(vars[0].id);
      vc.hidden = false;
    } else { vc.hidden = true; vc.innerHTML = ''; }
    var feats = safeParse(ds.features, []);
    el('[data-wf-qv-features]').innerHTML = feats.slice(0,6).map(function(f){
      var ic = f.icon ? '<span class="ic"><img src="'+f.icon+'" alt="" width="38" height="38" loading="lazy"></span>' : '<span class="ic"></span>';
      return '<div class="row">'+ic+'<div><b>'+(f.title||'')+'</b><span>'+(f.desc||'')+'</span></div></div>';
    }).join('');
    el('[data-wf-qv-about-title]').hidden = !feats.length;
    var lines = (ds.details || '').split('||').filter(function(l){ return l.trim(); });
    var dl = lines.map(function(l){ var i=l.indexOf(':'); if(i>0) return '<dt>'+l.slice(0,i).trim()+'</dt><dd>'+l.slice(i+1).trim()+'</dd>'; return '<dd>'+l.trim()+'</dd>'; }).join('');
    el('[data-wf-qv-specs]').innerHTML = dl ? '<dl>'+dl+'</dl>' : '';
    el('[data-wf-qv-spec-title]').hidden = !lines.length;
    var full = el('[data-wf-qv-full]');
    if (ds.url) { full.href = ds.url; full.removeAttribute('aria-disabled'); full.removeAttribute('tabindex'); }
    else { full.removeAttribute('href'); full.setAttribute('aria-disabled', 'true'); full.setAttribute('tabindex', '-1'); }
    var atc = el('[data-wf-qv-atc]'); atc.textContent = 'Add to bag'; atc.classList.remove('is-done');
    el('[data-wf-qv-msg]').textContent = '';
    var scrim = el('[data-wf-qv-scrim]');
    scrim.hidden = false; scrim.setAttribute('aria-hidden', 'false');
    qv.hidden = false; qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.setAttribute('aria-hidden', 'false'); qv.scrollTop = 0;
    var info = el('.wfc-qv-info'); if(info) info.scrollTop = 0;
    var gal = el('.wfc-qv-gallery'); if(gal) gal.scrollTop = 0;
    requestAnimationFrame(function(){ scrim.classList.add('is-open'); qv.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    var qv = el('[data-wf-qv]'), scrim = el('[data-wf-qv-scrim]'); if(!qv) return;
    scrim.classList.remove('is-open'); qv.classList.remove('is-open');
    scrim.setAttribute('aria-hidden', 'true');
    qv.setAttribute('aria-hidden', 'true'); qv.removeAttribute('role'); qv.removeAttribute('aria-modal');
    document.documentElement.style.overflow = '';
    setTimeout(function(){
      scrim.hidden = true; qv.hidden = true;
      var full = el('[data-wf-qv-full]');
      if (full) { full.removeAttribute('href'); full.setAttribute('aria-disabled', 'true'); full.setAttribute('tabindex', '-1'); }
    }, 320);
  }
  function openCartDrawer(){
    var cd = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
    if (cd){ if (typeof cd.open === 'function'){ cd.open(); return true; } if (typeof cd.showDialog === 'function'){ cd.showDialog(); return true; } }
    return false;
  }
  function addToBag(){
    if(!curVid){ return; }
    var atc = el('[data-wf-qv-atc]'); atc.textContent = 'Adding…';
    // 复刻 Horizon 原生 add 流程: 带 cart-items-component 的 sectionId 请求 → 返回 section HTML → 事件带 sections → 组件 morphSection(空→满可靠)
    var secIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component')).map(function(c){ return c.dataset.sectionId; }).filter(Boolean);
    var body = { items:[{ id: Number(curVid), quantity:1 }] };
    if (secIds.length){ body.sections = secIds.join(','); body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); }).then(function(res){
        atc.textContent = '✓ Added'; atc.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ data:{ source:'wf-quickview-atc', sections: res && res.sections } } }));
        setTimeout(function(){ if (openCartDrawer()) close(); else el('[data-wf-qv-msg]').innerHTML = 'Added &nbsp;·&nbsp; <a href="/cart" style="text-decoration:underline">View bag</a>'; }, 350);
      }).catch(function(){ atc.textContent = 'Add to bag'; el('[data-wf-qv-msg]').textContent = 'Could not add — try again.'; });
  }
  function fileKey(u){ return (u||'').split('?')[0].split('/').pop(); }
  function setMain(url){
    if(!url) return;
    var main = el('[data-wf-qv-main]'); if(main) main.src = url;
    var tb = el('[data-wf-qv-thumbs]'); if(tb){ var key = fileKey(url); tb.querySelectorAll('img').forEach(function(x){ x.classList.toggle('is-active', fileKey(x.getAttribute('src'))===key); }); }
  }
  document.addEventListener('click', function(ev){
    var vsel = ev.target.closest('[data-vsel]');
    if (vsel){ if(vsel.disabled) return; curVid = vsel.getAttribute('data-vsel');
      var box = el('[data-wf-qv-variants]'); if(box){ box.querySelectorAll('.wfc-qv-vbtn').forEach(function(x){ x.classList.remove('is-sel'); }); vsel.classList.add('is-sel'); }
      setMain(vsel.getAttribute('data-vimg')); return; }
    var th = ev.target.closest('[data-wf-thumb]');
    if (th){ setMain(th.getAttribute('src')); return; }
    var t = ev.target.closest('.wf-qv-trigger');
    if (t){ ev.preventDefault(); open(t.dataset); return; }
    if (ev.target.closest('[data-wf-qv-close]') || ev.target.matches('[data-wf-qv-scrim]')){ close(); return; }
    if (ev.target.closest('[data-wf-qv-atc]')){ addToBag(); return; }
  });
  document.addEventListener('keydown', function(ev){ if (ev.key === 'Escape') close(); });
  // portal 到 body 直接子级(脱离任何 stacking context, 盖住 header)
  function portalQv(){
    var qv = document.querySelector('[data-wf-qv]'), scrim = document.querySelector('[data-wf-qv-scrim]');
    if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
    if (qv && qv.parentNode !== document.body) document.body.appendChild(qv);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portalQv); else portalQv();
})();
  } catch(e) { console.error(e); }
})();

})();
